import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';
import { HiStar, HiCheckCircle } from 'react-icons/hi';

function Reviews() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    const reviews = [
        {
            id: 1,
            name: "Priya Sharma",
            title: "Outstanding Service!",
            text: "Astra Clean exceeded my expectations. The team arrived on time, worked efficiently, and left my home spotless.",
            rating: 5
        },
        {
            id: 2,
            name: "Rajesh Kumar",
            title: "Reliable and Professional",
            text: "I've tried several cleaning services, but Astra Clean stands out. Their attention to detail and professionalism is unmatched.",
            rating: 5
        },
        {
            id: 3,
            name: "Anjali Patel",
            title: "Perfect for Busy Schedules",
            text: "Booking was quick and easy, and I loved the flexible scheduling. The cleaners were friendly and did an excellent job.",
            rating: 5
        },
        {
            id: 4,
            name: "Vikram Singh",
            title: "Top-Notch Quality",
            text: "From start to finish, the service was excellent. Every corner was cleaned perfectly. Truly a 5-star experience.",
            rating: 5
        }
    ];

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <div className="bg-white min-h-screen">
            <HomeNav />
            
            {/* Reviews Hero */}
            <section className="pt-40 pb-20 bg-secondary relative overflow-hidden text-center">
                <div className="container-custom relative z-10 mx-auto max-w-3xl px-4">
                    <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Customer Stories</span>
                    <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                        Voice of our <span className="text-primary italic">Clients</span>
                    </h1>
                    <div className="flex items-center justify-center gap-2 mt-8">
                        <div className="flex text-amber-500">
                            {[...Array(5)].map((_, i) => <HiStar key={i} size={24} />)}
                        </div>
                        <span className="font-black text-foreground ml-2">4.9/5 Overall Rating</span>
                    </div>
                </div>
            </section>

            <section className="py-24">
                <div className="container-custom">
                    <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
                        {reviews.map((review) => (
                            <div key={review.id} className="break-inside-avoid card-premium p-8 space-y-6 hover:shadow-2xl transition-all border border-border/40">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center font-black text-sm">
                                            {review.name.split(' ').map(n => n[0]).join('')}
                                        </div>
                                        <div>
                                            <h4 className="font-bold text-foreground text-sm flex items-center gap-1">
                                                {review.name}
                                                <HiCheckCircle className="text-blue-500" size={14} title="Verified Customer" />
                                            </h4>
                                            <div className="flex text-amber-500">
                                                {[...Array(review.rating)].map((_, i) => <HiStar key={i} size={14} />)}
                                            </div>
                                        </div>
                                    </div>
                                    <span className="text-[3rem] font-serif inline-block leading-none text-primary/10 select-none">“</span>
                                </div>
                                
                                <div className="space-y-2">
                                    <h5 className="font-black text-foreground italic">"{review.title}"</h5>
                                    <p className="text-muted-foreground text-sm leading-relaxed font-medium">
                                        {review.text}
                                    </p>
                                </div>

                                <div className="pt-6 border-t border-border/40 flex items-center justify-between">
                                    <span className="text-[10px] font-black uppercase tracking-widest text-muted-foreground">Certified Experience</span>
                                    <span className="text-[10px] font-black uppercase tracking-widest text-muted-foreground">2 days ago</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Submit Review CTA */}
                    <div className="mt-24 text-center space-y-8 max-w-xl mx-auto">
                        <h2 className="text-3xl font-heading font-black">Experience the <span className="text-primary italic">Difference?</span></h2>
                        <p className="text-muted-foreground font-medium">Join thousands of satisfied clients who have transformed their lifestyle with AstraClean.</p>
                        <button className="btn-primary !px-12 !py-5 uppercase tracking-[0.2em] text-xs font-black">
                            Book Your Service
                        </button>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Reviews;

